import React, { useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import api from '../../api/axiosConfig';
import './ResetPassword.css';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const resetToken = searchParams.get('token');
  const navigate = useNavigate();

  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  if (!resetToken) {
    navigate('/login', { replace: true });
    return null;
  }

  const handleReset = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    if (newPassword !== confirmPassword) {
      setError('Las contraseñas no coinciden');
      setLoading(false);
      return;
    }

    if (newPassword.length < 6) {
      setError('La contraseña debe tener al menos 6 caracteres');
      setLoading(false);
      return;
    }

    try {
      const response = await api.post('/restablecerPassword', { resetToken, newPassword });

      if (response.data.result) {
        setSuccess(true);
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Error al restablecer la contraseña');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="reset-container">
      <div className="reset-card">
        {success ? (
          <div className="reset-success">
            <i className="bi bi-check-circle"></i>
            <h3>Contraseña restablecida</h3>
            <p>Tu contraseña se actualizó correctamente. Ya podés iniciar sesión con tu nueva contraseña.</p>
            <Link to="/login" className="reset-btn" style={{ textDecoration: 'none', display: 'inline-block' }}>
              Ir al inicio de sesión
            </Link>
          </div>
        ) : (
          <>
            <h2 className="reset-title">Nueva contraseña</h2>
            <p className="reset-subtitle">Ingresá tu nueva contraseña</p>

            {error && <div className="reset-error">{error}</div>}

            <form onSubmit={handleReset}>
              <div className="form-group" style={{ marginBottom: '16px' }}>
                <input
                  type="password"
                  className="reset-input"
                  value={newPassword}
                  onChange={e => setNewPassword(e.target.value)}
                  placeholder="Nueva contraseña"
                  required
                  disabled={loading}
                  minLength={6}
                />
              </div>
              <div className="form-group">
                <input
                  type="password"
                  className="reset-input"
                  value={confirmPassword}
                  onChange={e => setConfirmPassword(e.target.value)}
                  placeholder="Confirmar nueva contraseña"
                  required
                  disabled={loading}
                  minLength={6}
                />
              </div>
              <button type="submit" className="reset-btn" disabled={loading || !newPassword || !confirmPassword}>
                {loading ? 'Restableciendo...' : 'Restablecer contraseña'}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default ResetPassword;
